import { longDateTimeWithSeconds } from 'helpers/formatters'
import React from 'react'
import styled from 'styled-components'
import { color } from 'styles/colors'

type Props = {
  occurredAt: string;
  state: string;
}

const STATE = {
  'connected': 'Thermostat Connected: The thermostat has connected to Diagnostics.',
  'disconnected': 'Thermostat disconnected: The thermostat disconnected from Diagnostics due to a drop in Wifi connection, on-site networking problem, or power loss event.',
  'restarted': 'Thermostat reboot: The thermostat rebooted due to an on-screen reboot or power loss event.'
}

const DeviceConnectionStatusTooltipContent = ({ occurredAt, state }: Props) => {
  return (
    <S.Container>
      <S.Header>
        <S.Title>
          <S.Icon
            src="/img/alert-rth-spirte-icon/device_status_info.svg"
            alt="device status icon"
          />
          {`Device ${state}`}
        </S.Title>
        <S.Status>
          <span>occurred</span>
          <S.OccurredAt>{longDateTimeWithSeconds(occurredAt)}</S.OccurredAt>
        </S.Status>
      </S.Header>
      <S.Description>
        {STATE[state]}
      </S.Description>
    </S.Container>
  )
}

const S = {
  Container: styled.div`
    width: 100%;
    padding-left: 12px;
  `,
  Header: styled.div`
    font-weight: bold;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: ${color('secondaryText')};
  `,
  Icon: styled.img`
    width: 36px;
    height: 36px;
    margin-right: 20px;
  `,
  Title: styled.span`
    font-size: 24px;
    display: flex;
    font-weight: 600;
    color:${color('primaryText')};
  `,
  Status: styled.div`
    font-size: 16px;
    color: ${color('secondaryText')};
    font-weight: 600;
    text-transform:uppercase;
    text-align: right;
    padding-right: 20px;
  `,
  OccurredAt: styled.p`
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    color: ${color('primaryText')};
    margin: 0;
  `,
  Description: styled.p`
    font-size: 12px;
    text-align: left;
    line-height: 1.5;
    padding: 8px;
    color: ${color('secondaryText')};
  `
}

export default DeviceConnectionStatusTooltipContent
